import { React, useEffect, useState, useContext } from 'react'
import axios from "axios";
import { GlobalLoading, showLoading } from 'react-global-loading';
import { MyContextProvider } from "../../../App";
import { API_URL } from '../../../Constant';
import { generateExcel } from '../../../Custom/ExportExcel';
import { changeDateFormat, shortMonthToFull, validateRoles } from "../../../Custom/Custom";
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from "react-router-dom";
import titlesData from '../../../titles.json';



function PendencyReport() {


  const currentDate = new Date();
  const prevMonthDate = new Date(currentDate);
  prevMonthDate.setMonth(currentDate.getMonth() - 1);
  const prevMonthName = prevMonthDate.toLocaleString('default', { month: 'short' }).toUpperCase();
  const [years, setYears] = useState([]);
  const [yearName, setyearName] = useState(new Date().getFullYear());
  const [months, setMonth] = useState([]);
  const [monthName, setMonthName] = useState(prevMonthName);
  const token = useContext(MyContextProvider).token;
  const navigate = useNavigate();
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };


  useEffect(() => { //Get all Years Data
    //Years


    const fetchYears = async () => {
      showLoading(true)

      const currentYear = new Date().getFullYear();
      const endYear = 2021;
      const yearsArray = [];

      for (let year = currentYear; year >= endYear; year--) {
        yearsArray.push(year);
      }

      setYears(yearsArray);
      showLoading(false)


    };

    const fetchMonths = async () => {
      showLoading(true)

      axios
        .get(`${API_URL}api/graph/getMonths/2019`, config)
        .then((res) => {
          let monthDataResponse = res.data;
          if (monthDataResponse.status) {
            setMonth(monthDataResponse.data);
            showLoading(false)
          }
        })
        .catch((err) => {
          console.log(err)
          showLoading(false)
        });

    };

    const userRole = async () => {
      showLoading(true)
      try {
        const role = await validateRoles(jwtDecode(token));
        if (role) {
          // await Promise.all([fetchYears(), fetchMonths()]); // Using Promise.all to run both functions concurrently
          fetchYears()
          fetchMonths()
        } else {
          // setIsRole(false);
          alert("You are not an authorized user to capture the data for Pricing");
          navigate("/dashboard");
        }
      } catch (error) {
        console.log(error);
        showLoading(false)
      }
    }


    userRole();

  }, []);


  const handleSubmit = (e) => {
    showLoading(true)

    const excelObjectData = {
      fileName: "Price_PendencyReport",
      reportType: "PricePendencyReport",
      fileType: 'xls',
      sheetName: "PendencyReport",
      firstRowMergeCells: "A1:L1",
      firstRowText: "Pendency Report",
      firstRowExportDate: changeDateFormat(new Date()),
      firstRowCellNumber: 13,
      secondRowMergeCells: "A2:M2",
      secondRowText: `${monthName}-${yearName}`,
      secondRowExportDate: changeDateFormat(new Date()),// not require
      secondRowCellNumber: 13,// not require
      headerEnglishColumns: [
        'Division', 'District', 'Urban Consumer Price Input Form', 'Rural Consumer Retail Price',
        'Whole Sale Price', 'Urban Labour Wages Rates', 'Rural Labour Wages Rates (For Men)',
        'Rural Labour Wage Rates(For Women)', 'Retail Price For Necessary Items Lucknow',
        'Sixty Two Necessary Items', 'Whole Sale Raw Wool Price', 'Whole Sale Kanpur District',
        'Whole Sale Price For Agriculture Items of Hapur Mandi'
      ],
      headerHindiColumns: [
        'मण्डल', 'जिला', 'नगरीय उपभोक्ता मूल्य इनपुट फार्म', 'ग्रामीण उपभोक्ता खुदरा मूल्य',
        'थोक मूल्य', 'नगरीय श्रम मज़दूरी दर', 'ग्रामीण श्रम मज़दूरी दर ( पुरूषो के लिए )',
        'ग्रामीण श्रम मज़दूरी दर (स्त्रियो के लिए)', 'लखनऊ आवश्यक वस्तुओं के लिए फुटकर मूल्य',
        'बासठ आवश्यक वस्तुएँ', 'थोक मूल्य कच्चे ऊन', 'थोक मूल्य कानपुर जिला',
        'हापुड़ मंडी के थोक मूल्य कृषि  वस्तुएँ'

      ],
      excelRowData: [ // added data after get

      ]
    };


    let postData = {
      "monthInChar": monthName,
      "year": yearName,
    }
    axios
      .post(`${API_URL}api/price/getPendencyReports`, postData, config)
      .then((res) => {


        let pendencyDataResponse = res.data.data[0].GroupCodes;

        const transformedData = pendencyDataResponse.map(item => [
          `${item.DIVISION_NAME} (${item.DIVISION_CODE})` || 'NA',
          `${item.DISTRICT_NAME} (${item.DISTRICT_CODE})` || 'NA',
          item.urban_dist || 'NA',
          item.rural_dist || 'NA',
          item.whole_sale_dist || 'NA',
          item.urban_wage_dist || 'NA',
          item.ruralmen_wage_dist || 'NA',
          item.ruralwomen_wage_dist || 'NA',
          item.retail_lko || 'NA',
          item.retail_62 || 'NA',
          item.wholeSaleRawWool || 'NA',
          item.wholeSalekanpur || 'NA',
          item.wholeSalehapur || 'NA'

        ]);
        excelObjectData.excelRowData = transformedData;
        generateExcel(excelObjectData)
        showLoading(false)

      })
      .catch((err) => {
        console.log(err);
        showLoading(false)
      });

  }

  const storedLanguage = localStorage.getItem('language');


  return (

    <>

      <GlobalLoading />
      
      <div className="container-fluid py-3">
        <div className="card mx-3 mb-3">
          <div className="card-body pb-1">
            <div className="row align-items-center">
              <h4 className="page_heading"><span className="text_orange"> {storedLanguage === 'hi' ? titlesData.hi.PriceWagesIndicesSystem : titlesData.en.PriceWagesIndicesSystem}</span> Pendency Report</h4>
              <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
                <label>Month</label>

                <select value={monthName} onChange={(e) => (setMonthName(e.target.value))} name="month_name" className="form-select">
                  <option value="" disabled>Select Month</option>
                  {months && months.map((ele, i) => (
                    <option key={i} value={ele.MONTH}>{shortMonthToFull(ele.MONTH)}</option>
                  ))

                  }
                </select>

              </div>

              <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
                <label>Year</label>
                <select value={yearName} onChange={(e) => (setyearName(e.target.value))} name="year_name" className="form-select" >
                  <option value="" disabled >Select Year</option>
                  {years.map((ele, index) => (
                    <option key={index} value={ele}>
                      {ele}
                    </option>
                  ))}

                </select>
              </div>

              <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-12 mb-3">
                <label className="w-100 d-none d-sm-block">&nbsp;</label>
                <button onClick={handleSubmit} type="submit" className="btn btn_orange">Get Data</button>
              </div>
            </div>
          </div>
        </div>

      </div>

    </>
  )
}

export default PendencyReport